var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5606 6.81717L11.1533 3.83322C10.9746 3.68878 10.8268 3.50974 10.719 3.30684C10.6111 3.10393 10.5453 2.88133 10.5255 2.65238C10.5058 2.42344 10.5324 2.19285 10.6039 1.97446C10.6754 1.75606 10.7902 1.55435 10.9416 1.38141C11.0929 1.20846 11.2776 1.06786 11.4845 0.96801C11.6915 0.868162 11.9165 0.811132 12.1461 0.800338C12.3756 0.789542 12.605 0.825204 12.8204 0.905186C13.0358 0.985168 13.2329 1.10782 13.3998 1.2658L20.228 7.24051C20.4108 7.40073 20.5573 7.59814 20.6576 7.81952C20.758 8.04091 20.8099 8.28116 20.8099 8.52423C20.8099 8.76729 20.758 9.00755 20.6576 9.22893C20.5573 9.45031 20.4108 9.64772 20.228 9.80794L13.3998 15.7826C13.2329 15.9406 13.0358 16.0633 12.8204 16.1433C12.605 16.2232 12.3756 16.2589 12.1461 16.2481C11.9165 16.2373 11.6915 16.1803 11.4845 16.0804C11.2776 15.9806 11.0929 15.84 10.9416 15.667C10.7902 15.4941 10.6754 15.2924 10.6039 15.074C10.5324 14.8556 10.5058 14.625 10.5255 14.3961C10.5453 14.1671 10.6111 13.9445 10.719 13.7416C10.8268 13.5387 10.9746 13.3597 11.1533 13.2152L14.5606 10.2313L2.00003 10.2313C1.54729 10.2313 1.11309 10.0514 0.792956 9.7313C0.47282 9.41117 0.292969 8.97697 0.292969 8.52423C0.292969 8.07149 0.47282 7.63729 0.792956 7.31715C1.11309 6.99701 1.54729 6.81717 2.00003 6.81717L14.5606 6.81717Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.919071,
    y1: 15.2595,
    x2: 21.1592,
    y2: 14.4173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861035,
    stopColor: "#FC762A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.1999a6b8af2e93f2d32d7f2e0bf1a93c.svg";
export { ForwardRef as ReactComponent };